// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.TenantTrait

export enum TenantTrait {
  NO_COMPLAINTS = 'NO_COMPLAINTS',
  OTHER = 'OTHER',
  PAYS_ON_TIME = 'PAYS_ON_TIME',
  RARELY_REQUESTS_REPAIRS = 'RARELY_REQUESTS_REPAIRS',
  TAKES_CARE_OF_PROPERTY = 'TAKES_CARE_OF_PROPERTY',
}

export const TenantTrait_values = [
  TenantTrait.NO_COMPLAINTS,
  TenantTrait.OTHER,
  TenantTrait.PAYS_ON_TIME,
  TenantTrait.RARELY_REQUESTS_REPAIRS,
  TenantTrait.TAKES_CARE_OF_PROPERTY,
] as const;
